module.exports = __webpack_public_path__ + "img/news_post_7.808d66ff.jpg";